import { Outlet, Navigate } from "react-router-dom";
const AuthProtect = () => {
  const isAuth = localStorage.getItem("userId");

  if (isAuth) {
    return <Navigate to="/" />;
  } else return <Outlet />;
};
export default AuthProtect;
